import { render, staticRenderFns } from "./informationDetail.vue?vue&type=template&id=1f8b2a79&scoped=true"
import script from "./informationDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./informationDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./informationDetail.vue?vue&type=style&index=0&id=1f8b2a79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b2a79",
  null
  
)

export default component.exports